export { default } from './useAppInitialRouteName';
export * from './useAppInitialRouteName';
